/* global axios */
import ApiClient from './ApiClient';

class OperationsStreamAPI extends ApiClient {
  constructor() {
    super('operations', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  detail(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new OperationsStreamAPI();
